import styled from 'styled-components';
import {
  Grid,
  Button,
  media,
  EllipsisWithLineClamp,
} from '@simplywallst/ui-core';

export const ValuationContainer = styled(Grid)`
  border-radius: ${({ theme }) => `${theme.x1spacePx}px`};
  background-color: ${({ theme }) => theme.color.phantom};
  ${media.mdDown`
    margin: ${({ theme }) => `${theme.x1spacePx}px`} ${({ theme }) =>
    `${theme.x2spacePx}px`} 0;
  `}
`;

export const FairValueContainer = styled(Grid)`
  border-radius: ${({ theme }) => `${theme.x1spacePx}px`}
    ${({ theme }) => `${theme.x1spacePx}px`} 0 0;
  background-color: ${({ theme }) => theme.color.spaceGray};
  padding: ${({ theme }) => `${theme.x2spacePx}px`};
  ${media.mdDown`
    border-radius: 0px;
  `}
`;

export const Wrapper = styled(Grid)`
  padding: ${({ theme }) => `${theme.x2spacePx}px`};
`;

export const StyledSVG = styled.svg`
  min-width: 304px;
  min-height: 252px;
`;

export const ModalContent = styled(Grid)`
  padding: ${({ theme }) => `${theme.x3spacePx}px`};
  grid-auto-rows: max-content;
  overflow-y: auto;
  max-height: calc(100vh - 154px);
`;

export const ModalFooter = styled(Grid)`
  border-top: 1px solid ${({ theme }) => theme.color.whiteRGBA(0.2)};
  padding: ${({ theme }) => theme.x1spacePx}px;
`;

export const StyledButton = styled(Button)`
  box-shadow: none;
`;

export const Image = styled('img')`
  height: ${({ theme }) => `${theme.x3spacePx}px`};
  width: ${({ theme }) => `${theme.x3spacePx}px`};
  border-radius: 50%;
  border: 2px solid ${({ theme }) => theme.color.white};
`;

export const TruncatedValuation = styled('span')`
  ${EllipsisWithLineClamp(3)};
  ${({ theme }) => theme.typography.xSmall};
  color: ${({ theme }) => theme.color.lightGray};

  * {
    display: inline;
  }
`;
